var SwiperBlog = {
    init:function(){
        var swiper = new Swiper(".teases-blog-container .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 20,
            slideToClickedSlide:false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
              },
              breakpoints: {                  
                1040: {
                    spaceBetween: 45,
                 }
             }
          });
    }
}

$(window).load(function(){
    if($('.teases-blog-container').length){
        SwiperBlog.init();
    }
})